import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase.js'
import { loadChartExecutionHistory } from '../lib/loadChartExecutionHistory.js'

const EMPTY = Object.freeze([])

export function useChartExecutionHistory(userId, symbol, revision) {
  const [state, setState] = useState(null)
  const key = userId && symbol ? `${userId}:${symbol}` : null
  useEffect(() => {
    if (!key) { setState(null); return undefined }
    const controller = new AbortController()
    let current = true
    const timer = setTimeout(() => controller.abort(), 30000)
    setState({ key, status: 'loading', executions: EMPTY })
    loadChartExecutionHistory(supabase, userId, symbol, controller.signal).then(executions => {
      if (current) setState({ key, status: 'ready', executions })
    }).catch(() => {
      if (current) setState({ key, status: 'error', executions: EMPTY })
    }).finally(() => clearTimeout(timer))
    return () => { current = false; clearTimeout(timer); controller.abort() }
  }, [key, userId, symbol, revision])
  return state?.key === key && key ? state : { status: key ? 'loading' : 'idle', executions: EMPTY }
}
